import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  unreadMessagesNumber = signal(0)
}
